/** Auto-generated Excel column/header enums for versa exports. */

export enum VersaExcelHeader {
  Adult = "adult",
  AllowEarn = "allowEarn",
  Amount = "amount",
  Beds = "beds",
  BlockingOrder = "blockingOrder",
  BuildingCode = "buildingCode",
  CategoryName = "categoryName",
  CeilingLimit = "ceilingLimit",
  CentralResvEquivalent = "centralResvEquivalent",
  Characteristics = "characteristics",
  CheckPoints = "checkPoints",
  Child = "child",
  Code = "code",
  CommissionFlat = "commissionFlat",
  CommissionPercentage = "commissionPercentage",
  CondoAddress = "condoAddress",
  CondoContactDetails = "condoContactDetails",
  CondoDescription = "condoDescription",
  CondoFirstName = "condoFirstName",
  CondoLastName = "condoLastName",
  CondoNightAvailable = "condoNightAvailable",
  CondoRentedToGuest = "condoRentedToGuest",
  CondoRentedToOwner = "condoRentedToOwner",
  CondoRoomRevenue = "condoRoomRevenue",
  CondoUnitCondition = "condoUnitCondition",
  ConnectingRoomCodes = "connectingRoomCodes",
  CountRoomAs = "countRoomAs",
  CreditCardPreAuth = "creditCardPreAuth",
  CreditLimit = "creditLimit",
  DefaultAmount = "defaultAmount",
  DefaultFolio = "defaultFolio",
  DefaultMasterFolio = "defaultMasterFolio",
  DepartmentName = "departmentName",
  Description = "description",
  EffectiveDate = "effectiveDate",
  EnergySection = "energySection",
  ExemptDays = "exemptDays",
  ExtractCode = "extractCode",
  ExtractRevenueBucket = "extractRevenueBucket",
  FeeFrequency = "feeFrequency",
  Floor = "floor",
  FloorLimit = "floorLimit",
  GapTime = "gapTime",
  GiftCardType = "giftCardType",
  GlNumber = "glNumber",
  GlOffsetNumber = "glOffsetNumber",
  GroupFunctionality = "groupFunctionality",
  GuestTypeCode = "guestTypeCode",
  HousekeepingSection = "housekeepingSection",
  IsActivateInterface = "isActivateInterface",
  IsActive = "isActive",
  IsAllowOversell = "isAllowOversell",
  IsBedded = "isBedded",
  IsBeverage = "isBeverage",
  IsBlockRequired = "isBlockRequired",
  IsBlockingReminder = "isBlockingReminder",
  IsChargedToCondoOwner = "isChargedToCondoOwner",
  IsCommissionPercentage = "isCommissionPercentage",
  IsCommissionable = "isCommissionable",
  IsCondoOnly = "isCondoOnly",
  IsCotNotAllowed = "isCotNotAllowed",
  IsCredit = "isCredit",
  IsCribNotAllowed = "isCribNotAllowed",
  IsDeposit = "isDeposit",
  IsExcludeFlatTaxOnZeroCharge = "isExcludeFlatTaxOnZeroCharge",
  IsFood = "isFood",
  IsFoodAndBevClassifier = "isFoodAndBevClassifier",
  IsGSTTax = "isGSTTax",
  IsGiftCard = "isGiftCard",
  IsHourly = "isHourly",
  IsInterfacePostToCheckoutFolio = "isInterfacePostToCheckoutFolio",
  IsMovieRestrictions = "isMovieRestrictions",
  IsNightly = "isNightly",
  IsNoAutoPostRoomAndTax = "isNoAutoPostRoomAndTax",
  IsOCCTaxNoOfRooms = "isOCCTaxNoOfRooms",
  IsOccupancyTax = "isOccupancyTax",
  IsOther = "isOther",
  IsPasscode = "isPasscode",
  IsPerm = "isPerm",
  IsPetAllowed = "isPetAllowed",
  IsPostTaxToFirstFolio = "isPostTaxToFirstFolio",
  IsPostWithRoom = "isPostWithRoom",
  IsROH = "isROH",
  IsRequireComment = "isRequireComment",
  IsRequireReference = "isRequireReference",
  IsResource = "isResource",
  IsRestrictPOSChanges = "isRestrictPOSChanges",
  IsRestrictReservationPost = "isRestrictReservationPost",
  IsRoomRental = "isRoomRental",
  IsRoomRevenue = "isRoomRevenue",
  IsRouteLocalCalls = "isRouteLocalCalls",
  IsShowOnSplits = "isShowOnSplits",
  IsSkipResortFee = "isSkipResortFee",
  IsSmoking = "isSmoking",
  IsSpecializedUse = "isSpecializedUse",
  IsSuite = "isSuite",
  IsSystemRoom = "isSystemRoom",
  IsTaxable = "isTaxable",
  IsTurndown = "isTurndown",
  IsUnblockPasscode = "isUnblockPasscode",
  IsUseSpecialGuarantee = "isUseSpecialGuarantee",
  KeyNumber = "keyNumber",
  LastDecorated = "lastDecorated",
  LicenseFromDate = "licenseFromDate",
  LicenseToDate = "licenseToDate",
  ListOrder = "listOrder",
  MattressTurned = "mattressTurned",
  MaximumGuests = "maximumGuests",
  MaximumNights = "maximumNights",
  MaximumOccupancy = "maximumOccupancy",
  MinimumOccupancy = "minimumOccupancy",
  Name = "name",
  NoOfPets = "noOfPets",
  NoOfRooms = "noOfRooms",
  OwnershipType = "ownershipType",
  PSTTax = "pSTTax",
  ParentSegment1Code = "parentSegment1Code",
  PaymentType = "paymentType",
  PhoneRestrictions = "phoneRestrictions",
  PhysicalAddress = "physicalAddress",
  PostTypeCategory = "postTypeCategory",
  PostTypeGrouping = "postTypeGrouping",
  PostTypeName = "postTypeName",
  PostTypeNumber = "postTypeNumber",
  ResortFeeType = "resortFeeType",
  RoomFeatures = "roomFeatures",
  RoomLocations = "roomLocations",
  RoomNumber = "roomNumber",
  RoomStatus = "roomStatus",
  RoomTypeCode = "roomTypeCode",
  RoomsForOccupancyTax = "roomsForOccupancyTax",
  SageExtractNumber = "sageExtractNumber",
  SortOrder = "sortOrder",
  StayOverPoints = "stayOverPoints",
  SuiteRoomCodes = "suiteRoomCodes",
  TaxExemptCategories = "taxExemptCategories",
  TaxExemptCategory = "taxExemptCategory",
  TaxMaintenances = "taxMaintenances",
  TaxRangeTo = "taxRangeTo",
  TaxType = "taxType",
  Taxes = "taxes",
  Teen = "teen",
  Todlers = "todlers",
  Type = "type",
  VillaHomeTemplateCode = "villaHomeTemplateCode",
  Youth = "youth",
}

export enum VersaExcelSourceField {
  Adult = "adult",
  Amount = "amount",
  Beds = "beds",
  BlockingOrder = "blockingOrder",
  BuildingCode = "buildingCode",
  CategoryName = "categoryName",
  CeilingLimit = "ceilingLimit",
  CentralResvEquivalent = "centralResvEquivalent",
  Characteristics = "characteristics",
  CheckPoints = "checkPoints",
  Child = "child",
  Code = "code",
  CommissionFlat = "commissionFlat",
  CommissionPercentage = "commissionPercentage",
  CondoAddress = "condoAddress",
  CondoContactDetails = "condoContactDetails",
  CondoDescription = "condoDescription",
  CondoFirstName = "condoFirstName",
  CondoLastName = "condoLastName",
  CondoNightAvailable = "condoNightAvailable",
  CondoRendedToOwner = "condoRendedToOwner",
  CondoRentedToGuest = "condoRentedToGuest",
  CondoRoomRevenue = "condoRoomRevenue",
  CondoUnitCondition = "condoUnitCondition",
  ConnectingRoomCodes = "connectingRoomCodes",
  CountRoomAs = "countRoomAs",
  CreditCardPreAuth = "creditCardPreAuth",
  CreditLimit = "creditLimit",
  DefaultAmount = "defaultAmount",
  DefaultBuilding = "defaultBuilding",
  DefaultFolio = "defaultFolio",
  DefaultMasterFolio = "defaultMasterFolio",
  DepartmentName = "departmentName",
  Description = "description",
  EffectiveDate = "effectiveDate",
  EnergySection = "energySection",
  ExemptDays = "exemptDays",
  ExtractCode = "extractCode",
  ExtractRevenueBracket = "extractRevenueBracket",
  FeeFrequency = "feeFrequency",
  Floor = "floor",
  FloorLimit = "floorLimit",
  GapTime = "gapTime",
  GiftCardType = "giftCardType",
  GlNumber = "glNumber",
  GlOffsetNumber = "glOffsetNumber",
  GuestTypeCode = "guestTypeCode",
  HousekeepingSection = "housekeepingSection",
  IsActivateInterface = "isActivateInterface",
  IsActive = "isActive",
  IsAllowOversell = "isAllowOversell",
  IsBedded = "isBedded",
  IsBeverage = "isBeverage",
  IsBlockRequired = "isBlockRequired",
  IsBlockingReminder = "isBlockingReminder",
  IsChargedToCondoOwner = "isChargedToCondoOwner",
  IsCommisionable = "isCommisionable",
  IsCommissionPecentage = "isCommissionPecentage",
  IsCondoOnly = "isCondoOnly",
  IsCotNotAllowed = "isCotNotAllowed",
  IsCredit = "isCredit",
  IsCribNotAllowed = "isCribNotAllowed",
  IsDeposit = "isDeposit",
  IsExcludeFlatTaxOnZeroCharge = "isExcludeFlatTaxOnZeroCharge",
  IsFood = "isFood",
  IsFoodAndBevClassifier = "isFoodAndBevClassifier",
  IsGSTTax = "isGSTTax",
  IsGiftCard = "isGiftCard",
  IsHourly = "isHourly",
  IsInterfacePostToCheckoutFolio = "isInterfacePostToCheckoutFolio",
  IsMovieRestrictions = "isMovieRestrictions",
  IsNightly = "isNightly",
  IsNoAutoPostRoomAndTax = "isNoAutoPostRoomAndTax",
  IsOCCTaxNoOfRooms = "isOCCTaxNoOfRooms",
  IsOccupancyTax = "isOccupancyTax",
  IsOther = "isOther",
  IsPasscode = "isPasscode",
  IsPerm = "isPerm",
  IsPetAllowed = "isPetAllowed",
  IsPostTaxToFirstFolio = "isPostTaxToFirstFolio",
  IsPostWithRoom = "isPostWithRoom",
  IsROH = "isROH",
  IsRequireComment = "isRequireComment",
  IsRequiredReference = "isRequiredReference",
  IsResource = "isResource",
  IsRestrictPOSChanges = "isRestrictPOSChanges",
  IsRestrictReservationPost = "isRestrictReservationPost",
  IsRoomRental = "isRoomRental",
  IsRoomRevenue = "isRoomRevenue",
  IsRouteLocalCalls = "isRouteLocalCalls",
  IsShowOnSplits = "isShowOnSplits",
  IsSkipResortFee = "isSkipResortFee",
  IsSmoking = "isSmoking",
  IsSpecializedUse = "isSpecializedUse",
  IsSuite = "isSuite",
  IsSystemRoom = "isSystemRoom",
  IsTaxable = "isTaxable",
  IsTurndown = "isTurndown",
  IsUnblockPasscode = "isUnblockPasscode",
  IsUseSpecialGuarentee = "isUseSpecialGuarentee",
  KeyNumber = "keyNumber",
  LastDecorated = "lastDecorated",
  LicenseFromDate = "licenseFromDate",
  LicenseToDate = "licenseToDate",
  ListOrder = "listOrder",
  MatressTurned = "matressTurned",
  MaximumGuests = "maximumGuests",
  MaximumNights = "maximumNights",
  MaximumOccupancy = "maximumOccupancy",
  MinimumOccupancy = "minimumOccupancy",
  Name = "name",
  NoOfPets = "noOfPets",
  NoOfRooms = "noOfRooms",
  OwnershipType = "ownershipType",
  PSTTax = "pSTTax",
  ParentSegment1Code = "parentSegment1Code",
  PaymentType = "paymentType",
  PhoneRestrictions = "phoneRestrictions",
  PhysicalAddress = "physicalAddress",
  PostTypeCategory = "postTypeCategory",
  PostTypeName = "postTypeName",
  PostTypeNumber = "postTypeNumber",
  ResortFeeType = "resortFeeType",
  RoomFeatures = "roomFeatures",
  RoomLocations = "roomLocations",
  RoomNumber = "roomNumber",
  RoomStatus = "roomStatus",
  RoomTypeCode = "roomTypeCode",
  RoomsForOccupancyTax = "roomsForOccupancyTax",
  SageExtractNumber = "sageExtractNumber",
  StayOverPoints = "stayOverPoints",
  SuiteRoomCodes = "suiteRoomCodes",
  TaxExemptCategories = "taxExemptCategories",
  TaxExemptCategory = "taxExemptCategory",
  TaxMaintenances = "taxMaintenances",
  TaxRangeTo = "taxRangeTo",
  TaxType = "taxType",
  Taxes = "taxes",
  Teen = "teen",
  Todlers = "todlers",
  Type = "type",
  VillaHomeTemplateCode = "villaHomeTemplateCode",
  Youth = "youth",
}

export enum VersaExcelSheetName {
  Building = "Building",
  Category = "Category",
  Department = "Department",
  GuestType = "Guest Type",
  HouseKeepingSections = "HouseKeeping Sections",
  Origins = "Origins",
  PaymentMethod = "Payment Method",
  PostType = "Post Type",
  RoomDefinition = "Room Definition",
  RoomFeature = "Room Feature",
  RoomLocation = "Room Location",
  RoomTypeMaintenance = "Room Type Maintenance",
  Segment1 = "Segment 1",
  Segment2 = "Segment 2",
  Tax = "Tax",
  TaxExemptCategories = "Tax Exempt Categories",
}
